var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1300_27561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2907 14.2172L21.2966 10.6515C20.4333 10.0348 19.3279 9.90575 18.3529 10.308L16.579 11.0392C16.2059 11.1932 15.7897 11.1932 15.4166 11.0392L13.6427 10.308C12.6695 9.90808 11.5671 10.037 10.7053 10.6515L5.71119 14.2172C5.32522 14.4958 5.08131 14.9389 5.04711 15.4237C5.0129 15.9085 5.19204 16.3834 5.53484 16.7167C8.99919 20.0918 12.5376 21.7783 16.0009 21.7783C19.4642 21.7783 23.0027 20.0907 26.467 16.7167C26.8098 16.3834 26.989 15.9085 26.9548 15.4237C26.9205 14.9389 26.6766 14.4958 26.2907 14.2172Z",
    fill: "#FF8D9B",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05859 15.3174H26.9435",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1300_27561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 14,
    fill: "white",
    transform: "translate(4 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLips);
export default __webpack_public_path__ + "static/media/lips.b03a27f6656dac70648a9f010766d978.svg";
export { ForwardRef as ReactComponent };